import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import FormInput from 'components/forms/FormInput';
import { ROLE_ROOT_EMPLOYEE, ROLE_ADMIN } from 'js/constants';
import may from 'js/security';
import IconRadioGroup from "../../forms/IconRadioGroup";
import EntityPropsUpdater from "../../../component/EntityPropsUpdater";
import {forEach as _forEach} from "lodash";

class ClientVendor extends React.Component {
  /*
  updateEntity = (propertyName, value) => {
    const { entity, changeEntity } = this.props;

    const newEntity = { ...entity.updateValue(propertyName, value, ['financial']) };

    changeEntity(newEntity);
  };

  updateBankEntity = (propertyName, value) => {
    const { entity, changeEntity } = this.props;

    const newEntity = { ...entity.updateValue(propertyName, value, ['financial', 'bankData']) };

    changeEntity(newEntity);
  };
*/

  updateVendorData = (name, value, tree) => {
    const { entity, changeEntity } = this.props;
    const newEntity = { ...entity.updateValue(name, value, tree) };
    changeEntity(newEntity);
  }

  updateVendorDataRadio = (name, value, tree) => {
    const { entity, changeEntity } = this.props;
    const newEntity = { ...entity.updateValue(name, value, tree) };
    changeEntity(newEntity);
  }

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
    } = this.props;

    const vendorData = entityLoaded && entity.getVendorData();
    const treeVendorData = ['vendorData'];
    const treeVendorPricing = ['vendorData', 'pricingBy'];
    const treeVendorOrdering = ['vendorData', 'orderingBy'];

    return (
      <div className="clearfix">
        {entityLoaded && (
          <>
            <Row>
              <Col xs={12} >
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <p className="m-t-10">{messages.formGroup.basic_information}</p>
                    <div className="form-group-attached">
                      <div className="form-group form-group-default padding-10">

                        <FormInput
                          ref="vendor_api"
                          label={messages.vendors.vendor_api}
                          name="serviceName"
                          value={vendorData.serviceName}
                          onChange={(name, value) => this.updateVendorData(name, value, treeVendorData)}
                        />

                        <FormInput
                          ref="vendors_order_email"
                          label={messages.vendors.order_email}
                          name="orderingEmailAddress"
                          value={vendorData.orderingBy.orderingEmailAddress}
                          onChange={(name, value) => this.updateVendorData(name, value, treeVendorOrdering)}
                        />

                        <FormInput
                          ref="order_phone_number"
                          label={messages.vendors.phone_number}
                          name="orderingPhoneNumber"
                          value={vendorData.orderingBy.orderingPhoneNumber}
                          onChange={(name, value) => this.updateVendorData(name, value, treeVendorOrdering)}
                        />

                        <FormInput
                          ref="web_shop_url"
                          label={messages.vendors.web_shop_url}
                          name="orderingURL"
                          value={vendorData.orderingBy.orderingURL}
                          onChange={(name, value) => this.updateVendorData(name, value, treeVendorOrdering)}
                        />

                      </div>

                    </div>


                    <p className="m-t-10">{messages.vendors.pricing}</p>
                    <div className="form-group-attached">
                      <div className="form-group form-group-default padding-10">


                        <div className="FormOwnStyle">

                          <p>{messages.vendors.operating_mode}</p>
                          <IconRadioGroup
                            name="priceOperationalMode"
                            variant="primary"
                            data={[
                              { value: 0,  label: messages.vendors.trial },
                              { value: 1,  label: messages.vendors.live },
                            ]}
                            value={vendorData.pricingBy.priceOperationalMode ? [Number.parseInt(vendorData.pricingBy.priceOperationalMode)] : [0]}
                            onChange={(value, name) => this.updateVendorDataRadio(name, value, treeVendorPricing)}
                          />


                          <p>{messages.vendors.price_update_method}</p>
                          <IconRadioGroup
                            name="priceUpdateMethod"
                            variant="primary"
                            data={[
                              { value: 0,  label: messages.vendors.prices_by_vendor },
                              { value: 1,  label: messages.vendors.prices_by_employee },
                              { value: 2,  label: messages.vendors.prices_by_api },
                            ]}
                            value={vendorData.pricingBy.priceUpdateMethod ? [Number.parseInt(vendorData.pricingBy.priceUpdateMethod)] : [0]}
                            onChange={(value, name) => this.updateVendorDataRadio(name, value, treeVendorPricing)}
                          />

                        </div>

                      </div>

                    </div>


                    <p className="m-t-10">{messages.vendors.order_processing}</p>
                    <div className="form-group-attached">
                      <div className="form-group form-group-default padding-10">


                        <div className="FormOwnStyle">

                          <p>{messages.vendors.operating_mode}</p>
                          <IconRadioGroup
                            name="orderOperationalMode"
                            variant="primary"
                            data={[
                              { value: 0,  label: messages.vendors.trial },
                              { value: 1,  label: messages.vendors.live },
                            ]}
                            value={vendorData.orderingBy.orderOperationalMode ? [Number.parseInt(vendorData.orderingBy.orderOperationalMode)] : [0]}
                            onChange={(value, name) => this.updateVendorDataRadio(name, value, treeVendorOrdering)}
                          />




                          <p>{messages.vendors.order_method}</p>
                          <IconRadioGroup
                            name="orderMethod"
                            variant="primary"
                            data={[
                              { value: 0,  label: messages.vendors.notified_by_email },
                              { value: 1,  label: messages.vendors.accepts_only_email },
                              { value: 2,  label: messages.vendors.use_webshop },
                              { value: 3,  label: messages.vendors.order_by_api },
                              { value: 4,  label: messages.vendors.order_by_api_and_webshop },
                            ]}
                            value={vendorData.orderingBy.orderMethod ? [Number.parseInt(vendorData.orderingBy.orderMethod)] : [0]}
                            onChange={(value, name) => this.updateVendorDataRadio(name, value, treeVendorOrdering)}
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}
      </div>
    );
  }
}
ClientVendor.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientVendor));
